import type { Analytics } from '@mwl/core-lib';

export const getFavoriteButtonAnalytics = (isFavorite: boolean): Analytics => {
  const eventName = isFavorite ? 'gamePage_delFavorite_icon_click' : 'gamePage_addFavorite_icon_click';

  return { click: { eventName } };
};
